import { render, staticRenderFns } from "./FormaRecebimento.vue?vue&type=template&id=16205feb"
import script from "./FormaRecebimento.vue?vue&type=script&lang=js"
export * from "./FormaRecebimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports